//
// Spin Controller
//
// ----------------------------
spinController = {};
spinController.mainSpinConfig = {};
spinController.mainLandConfig = {};
spinController.landSymbols = [];
spinController.reelCount = 5;
spinController.totalSpinTime = 2.0;

spinController.startSpin = function () {
  let reelStartOffset = 0.05;
  let pullback = 0.1;
  let accelTime = 0.5;
  let decelTime = 0.5;
  let bounce = 0.1;
  let mainSpin = 0.3;

  if (gameData.license === 'DE') {
    mainSpin = 3.5;
  }

  if (gameController.minimumGameTime > spinController.totalSpinTime) {
    spinController.totalSpinTime = gameController.minimumGameTime;
  }

  spinController.mainSpinConfig = {};
  spinController.mainLandConfig = {};

  for (let i = 0; i < spinController.reelCount; i++) {
    let mainReel = {
      type: 'main',
      startDelay: 0.0,
      reelStartDelayOffset: i * reelStartOffset,
      pullbackAmount: 0.3,
      pullbackTime: pullback,
      pullbackStrength: 1.0,
      accelerationTime: accelTime,
      accelerationStrength: 2.0,
      symbolsPerSecond: 20,
      mainReelSpinTime: mainSpin,
      mainReelSpinTimeReelOffset: i * 0.15,
      decelerationTime: decelTime,
      decelerationStrength: 2.0,
      bounceAmount: 25,
      bounceTime: bounce,
    };
    spinController.mainSpinConfig[`reel${i}`] = mainReel;
  }

  gameController.slotMachine.dynamicSpin(spinController.mainSpinConfig);
};

spinController.stopSpin = function (symbols, above, below, mainSpinCompleteCallback) {
  spinController.longSpinMainReels = [false, false, false, false, false];

  spinController.landSymbols = symbols;
  spinController.checkForLongSpinReels();
  spinController.setupLandConfigs();

  gameController.slotMachine.stopReels(symbols, above, below, mainSpinCompleteCallback, spinController.mainLandConfig);
};

spinController.setupLandConfigs = function () {
  for (let i = 0; i < spinController.reelCount; i++) {
    let mainReel = {};
    spinController.mainLandConfig[`reel${i}`] = mainReel;
  }
};

spinController.checkForLongSpinReels = function () {};

StateMachine.Create(spinController);

spinController.update = function (delta, time) {
  spinController.stateMachine.update();
};

spinController.stateMachine.addState('IDLE', function () {});

Reflex.addToUpdate(spinController.update);
